import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

// Services
import ActivityService from '../../services/activity-service';
import ClassroomService from '../../services/classroom-service';
import SchoolService from '../../services/school-service';
import StorageService from '../../services/storage-service';
import FileStorageService from '../../services/file-storage-service';

// Containers
import ActivityFollow from './activity-follow';
import ActivityEdit from './activity-edit';

// Components
import Loading from '../../components/loading/loading';
import ErrorComponent from '../../components/error/error';

const ActivityEditFollow = () => {
  const { activityId } = useParams<{ activityId: string }>();
  const [error, setError] = useState(false);

  const [active, setActive] = useState<boolean | null>(null);
  const [activity, setActivity] = useState<ActivityDto>(null);
  const [activityDetail, setActivityDetail] = useState<BackofficeActivityDetailDto>(null);
  const [classroomList, setClassroomList] = useState<ClassroomStudents[] | null>(null);
  const [activityService, setActivityService] = useState<ActivityService | null>(null);
  const [fileStorageService, setFileStorageService] = useState<FileStorageService | null>(null);

  useEffect(() => {
    const schoolService = new SchoolService();
    const storageService = new StorageService();
    const schoolId = storageService.getEmployee().schoolId;

    let service: ActivityService;

    schoolService
      .getSchoolById(schoolId)
      .then((school) => {
        service = new ActivityService(school.uuid);

        setActivityService(service);
        setFileStorageService(new FileStorageService(school.uuid));

        return service.getBackoffice(activityId);
      })
      .then((detail) => {
        setActive(detail.isScheduled);

        if (detail.isScheduled) {
          // A edição usa a rota canônica: o PUT substitui fileIds e studentUuids
          // por completo, então o formulário precisa deles crus.
          const classroomService = new ClassroomService();

          return Promise.all([
            service.getActivity(activityId),
            classroomService.listClassroomStudents(),
          ]).then(([fullActivity, classrooms]) => {
            setActivity(fullActivity);
            setClassroomList(classrooms);
          });
        }

        setActivityDetail(detail);
      })
      .catch(() => setError(true));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (error) return <ErrorComponent type='contentFull' />;

  if (active === null || !activityService || !fileStorageService)
    return <Loading type='contentFull' />;

  if (active) {
    if (!activity || !classroomList) return <Loading type='contentFull' />;

    return (
      <ActivityEdit
        activity={activity}
        classroomList={classroomList}
        activityService={activityService}
        fileStorageService={fileStorageService}
      />
    );
  }

  if (!activityDetail) return <Loading type='contentFull' />;

  return <ActivityFollow activity={activityDetail} activityService={activityService} />;
};

export default ActivityEditFollow;
